import { Cupom } from '../shared/entity/Cupom';
import api from './api';

const BASE_URL = '/cupom';

class cupomApi {
  async verificarCupom(codigo: string) {
    try {
      let res = await api.get<Cupom>(BASE_URL + '/verificar', { params: { codigo } });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new cupomApi();
